export default "__VITE_ASSET__119498ad__"